import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { TextField, IconButton } from '@picsio/ui';
import { AddPreset } from '@picsio/icons';
import Icon from '../Icon';
import Tooltip from '../Tooltip';

import MenuItem from './MenuItem';

const Presets = (props) => {
  const {
    isLoading, presets, selectedPreset, onChange, onRemove, onSave, canSave, label,
  } = props;
  const { _id: selectedId, name: selectedName, data: selectedData } = selectedPreset;
  const renderValue = () => selectedName;
  // Curated default social presets (Instagram Post / Facebook Post / …) are
  // fixed by product — users cannot derive new saved presets from them.
  const isDefaultSocialPreset = !!selectedPreset.isDefault;
  const isDisabledSave = selectedId === 'original'
    || !!selectedData.resolution
    || !!selectedData.usePdfProxy
    || isDefaultSocialPreset;

  return (
    <div className="downloadDialog__presets">
      <div className="downloadDialog__presets__select">
        <TextField
          label={label}
          name="presets"
          value={selectedId}
          onChange={onChange}
          disabled={isLoading}
          select
          LabelProps={{
            id: 'label-presets',
          }}
          SelectProps={{
            labelId: 'label-presets',
            dataId: '_id',
            dataValue: 'name',
            options: presets,
            optionComponent: (args) => (<MenuItem onRemove={onRemove} {...args} />),
            renderValue,
            MenuProps: {
              PopperProps: {
                portalContainer: document.querySelector('.wrapperDownloadDialog'),
              },
            },
          }}
        />
      </div>
      <If condition={canSave}>
        <div className="downloadDialog__presets__save">
          <Tooltip content={isDisabledSave ? null : 'Save as new preset'}>
            <IconButton
              onClick={onSave}
              disabled={isDisabledSave}
            >
              <Choose>
                <When condition={isLoading}>
                  <Icon className="sync-loading" name="sync" />
                </When>
                <Otherwise>
                  <AddPreset />
                </Otherwise>
              </Choose>
            </IconButton>
          </Tooltip>
        </div>
      </If>
    </div>
  );
};

Presets.defaultProps = {
  canSave: true,
  label: 'Save as',
};

Presets.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  presets: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
  selectedPreset: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    isDefault: PropTypes.bool,
    data: PropTypes.object,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  canSave: PropTypes.bool,
  /** Label displayed above the preset selector. Defaults to "Save as". */
  label: PropTypes.string,
};

export default memo(Presets);
